var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Page',{attrs:{"title":_vm.vm.title,"loading":_vm.vm.loadPageRequest.loading,"error":_vm.vm.loadPageRequest.error},on:{"reload":function($event){return _vm.controller.init()}}})}
var staticRenderFns = []

export { render, staticRenderFns }